<div class="select-checkbox">
  <nz-checkbox-group [(ngModel)]="dataSource" (ngModelChange)="selected.emit($event)"></nz-checkbox-group>
</div>
